import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { navItems } from '../../data/navigation';
import { useLocalizedPath } from '../../routes/useLanguageSync';
import { ReactComponent as Logo } from '../../assets/images/logo-with-slogen.svg';
import SocialLinks from '../SocialLinks/SocialLinks';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const getPath = useLocalizedPath();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.column}>
          <Link to="/" className={styles.logo}>
            <Logo className={styles.logoIcon} />
          </Link>
        </div>

        <div className={styles.column}>
          <h4 className={styles.columnTitle}>{t('footer.quickLinks')}</h4>
          <ul className={styles.linkList}>
            {navItems.map((item) => (
              <li key={item.routeKey}>
                <Link to={getPath(item.routeKey, item.routeParams)} className={styles.link}>
                  {t(item.labelKey)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.column}>
          <h4 className={styles.columnTitle}>{t('footer.contactInfo')}</h4>
          <ul className={styles.contactList}>
            <li>
              <a href="mailto:hello@chipet.app" className={styles.link}>
                hello@chipet.app
              </a>
            </li>
            <li>
              <a href="tel:+36303017733" className={styles.link}>
                +36 30 301 7733
              </a>
            </li>
          </ul>
          <SocialLinks />
        </div>
      </div>

      <div className={styles.bottom}>
        <div className="container">
          <div className={styles.bottomContent}>
            <p className={styles.copyright}>
              {t('footer.copyright', { year: currentYear })}
            </p>
            <div className={styles.legalLinks}>
              <a href="/docs/aszf.pdf" target="_blank" rel="noopener noreferrer" className={styles.legalLink}>
                {t('footer.terms')}
              </a>
              <a href="/docs/adatkezelesi-tajekoztato.pdf" target="_blank" rel="noopener noreferrer" className={styles.legalLink}>
                {t('footer.privacy')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
